import React from "react";
import Parse from "parse";

import { Button, Space, Tooltip } from "antd";

import { Icon } from "@opendash/icons";
import { useTranslation } from "@opendash/core";

interface Props {
  objects: Parse.Object[];
  current: Parse.Object;
  onChange(): void;
}

export const ParseObjectOrderButtons = React.memo<Props>(
  function ParseObjectOrderButtons({ objects, current, onChange }) {
    const t = useTranslation();
    return (
      <Space direction="horizontal">
        <Tooltip overlay={t("app:ui.order.tooltip_up")}>
          <Button
            key="up"
            icon={<Icon icon="fa:chevron-up" />}
            disabled={objects.indexOf(current) === 0}
            onClick={() => {
              const a = current;
              const aIndex = objects.indexOf(current);
              const bIndex = aIndex - 1;
              const b = objects[bIndex];

              for (const invoice of objects) {
                const index = objects.indexOf(invoice);

                if (invoice === a) {
                  invoice.set("order", 1000 - bIndex);
                } else if (invoice === b) {
                  invoice.set("order", 1000 - aIndex);
                } else {
                  invoice.set("order", 1000 - index);
                }
              }

              Parse.Object.saveAll(objects).then(() => {
                onChange();
              });
            }}
          />
        </Tooltip>
        <Tooltip overlay={t("app:ui.order.tooltip_down")}>
          <Button
            key="down"
            icon={<Icon icon="fa:chevron-down" />}
            disabled={objects.indexOf(current) === objects.length - 1}
            onClick={() => {
              const a = current;
              const aIndex = objects.indexOf(current);
              const bIndex = aIndex + 1;
              const b = objects[bIndex];

              for (const invoice of objects) {
                const index = objects.indexOf(invoice);

                if (invoice === a) {
                  invoice.set("order", 1000 - bIndex);
                } else if (invoice === b) {
                  invoice.set("order", 1000 - aIndex);
                } else {
                  invoice.set("order", 1000 - index);
                }
              }

              Parse.Object.saveAll(objects).then(() => {
                onChange();
              });
            }}
          />
        </Tooltip>
      </Space>
    );
  }
);
